"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var browser_1 = require("@sentry/browser");
var uuid_1 = require("uuid");
/**
 * Hook for handling single file uploads.
 */
function useFileUpload(storage, _a) {
    var onUploadSuccess = _a.onUploadSuccess, onUploadStart = _a.onUploadStart, _b = _a.maxSize, maxSize = _b === void 0 ? 10 : _b;
    // ID of the file stored in Firebase Cloud Storage
    var _c = __read(react_1.useState(uuid_1.v4()), 1), id = _c[0];
    // Status is one of: empty, processing, uploading, complete
    var _d = __read(react_1.useState('empty'), 2), status = _d[0], setStatus = _d[1];
    // The latest file object from the input file list
    var _e = __read(react_1.useState(null), 2), file = _e[0], setFile = _e[1];
    // The file name, used to clear the input
    // by setting it to an empty string
    var _f = __read(react_1.useState(''), 2), value = _f[0], setValue = _f[1];
    // The uploaded file's download URL
    var _g = __read(react_1.useState(''), 2), url = _g[0], setUrl = _g[1];
    // File upload progress percentage
    var _h = __read(react_1.useState(0), 2), progress = _h[0], setProgress = _h[1];
    var _j = __read(react_1.useState(''), 2), error = _j[0], setError = _j[1];
    // The firebase storage upload task
    var uploadTask;
    // Callback applied to a file input field
    function upload(uploadFile) {
        if (uploadFile) {
            setFile(uploadFile);
            setValue(uploadFile.name);
            setError('');
            if (uploadFile.size / 1024 / 1024 > maxSize) {
                setStatus('error');
                setError("Your file is over the " + maxSize + "MB limit.");
                return;
            }
            try {
                // Upload file
                setStatus('uploading');
                uploadTask = storage.ref(id).put(uploadFile);
                if (onUploadStart) {
                    onUploadStart(id, uploadFile);
                }
                // Register three observers:
                // 1. 'state_changed' observer, called any time the state changes
                // 2. Error observer, called on failure
                // 3. Completion observer, called on successful completion
                uploadTask.on('state_changed', function (snapshot) {
                    // Observe progress state
                    // Calculate task progress by dividing the number of bytes
                    // uploaded by the total number of bytes to be uploaded
                    setProgress(Math.floor((snapshot.bytesTransferred / snapshot.totalBytes) * 100));
                }, function (error) {
                    // Handle unsuccessful uploads
                    setError(error.message);
                    // Log the error with Sentry
                    browser_1.captureException(error);
                }, function () {
                    // Handle successful uploads
                    // Get the download URL
                    uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                        setStatus('complete');
                        setUrl(downloadURL);
                        // If an onUploadSuccess callback is
                        // defined, call it
                        if (uploadFile && onUploadSuccess) {
                            onUploadSuccess(downloadURL, id, uploadFile);
                        }
                    });
                });
            }
            catch (error) {
                setError(error);
                // Log the error with Sentry
                browser_1.captureException(error);
            }
        }
    }
    function onChange(event) {
        // This hook only supports single file uploads
        // so we get the first file from the file list
        if (event.target && event.target.files) {
            var uploadFile = event.target.files[0];
            upload(uploadFile);
        }
    }
    // Clear the field and reset internal state
    function clear() {
        setValue('');
        setFile(null);
        setUrl('');
        setError('');
        setProgress(0);
        setStatus('empty');
        // Cancel the upload if it exists
        if (typeof uploadTask !== 'undefined') {
            uploadTask.cancel();
        }
    }
    return {
        id: id,
        file: file,
        value: value,
        onChange: onChange,
        upload: upload,
        status: status,
        url: url,
        error: error,
        progress: progress,
        clear: clear,
    };
}
exports.default = useFileUpload;
//# sourceMappingURL=useFileUpload.js.map